import { useState } from 'react'

import { SelectOption } from 'components/Select'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { domainFromDTO } from './api/mapper'
import { GET_DOMAINS } from './api/query'
import { Data, DomainSliceDTO, Variables } from './api/types'
import { DomainSlice, UseGetDomainsForSelect } from './types'

export const useGetDomainsForSelect = (): UseGetDomainsForSelect => {
  const { workspaceId } = useWorkspaceParam()
  const [domains, setDomains] = useState<SelectOption<DomainSlice>[]>([])

  useQuery<Variables, Data>({
    onCompleted: async data => {
      const {
        domains: { nodes: domains },
      } = data

      if (domains && domains.length > 0) {
        setDomains(
          domains.map((domain: DomainSliceDTO): SelectOption<DomainSlice> => domainFromDTO(domain)),
        )
      }
    },
    query: GET_DOMAINS,
    variables: {
      workspaceId,
    },
  })

  return { domains }
}
